module.exports = __webpack_public_path__ + "static/livesnippet-6db5950047b89ae44f3e34de7fdff0b0.png";